import styled from 'styled-components';

export const Wrapper = styled.footer`
  padding: var(--gap);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap);

  @media screen and (min-width: 769px) {
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media screen and (min-width: 1200px) {
    display: grid;
    grid-template-columns: auto auto auto;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--gap);

  a {
    white-space: nowrap;
  }

  @media screen and (min-width: 769px) {
    justify-content: flex-start;
  }

  @media screen and (min-width: 1200px) {
    flex-wrap: nowrap;
  }
`;

export const SocialMedia = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--gap);
`;

export const Underlay = styled.div`
  display: block;
  position: absolute;
  z-index: -1;
  inset: 0;
  border-radius: var(--border-radius-round);
  background: var(--primary-light);
  opacity: 0;
  scale: 0.85;
  transition:
    background-color ease-in-out 200ms,
    opacity ease-out 100ms,
    scale ease-out 100ms;
`;

export const Link = styled.a`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: inherit;

  &:hover,
  &:focus {
    ${Underlay} {
      opacity: 1;
      scale: 1;
    }
  }
`;

export const Icon = styled.span`
  width: 24px;
  height: 24px;
  line-height: 0;
`;

export const Copyright = styled.p`
  margin: 0;
  text-align: center;

  @media screen and (min-width: 769px) {
    flex-grow: 1;
    width: 100%;
  }

  @media screen and (min-width: 1200px) {
    flex-grow: 0;
    text-align: right;
  }
`;
